import { render } from "./CoverArtistAlbums.vue?vue&type=template&id=36277036"
import script from "./CoverArtistAlbums.vue?vue&type=script&lang=js"
export * from "./CoverArtistAlbums.vue?vue&type=script&lang=js"

import "./CoverArtistAlbums.vue?vue&type=style&index=0&id=36277036&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__